import React from "react";
import { X, Folder, FolderTree } from "lucide-react";

export default function UploadFolderModal({
  show,
  folders,
  selectedFolderId,
  onSelectFolder,
  onClose,
  onConfirm,
  loading = false,
}) {
  if (!show) return null;

  const renderFolders = (parentId = null, depth = 0) => {
    return folders
      .filter(
        (folder) =>
          folder.itemType === "folder" && folder.parentId === parentId,
      )
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((folder) => (
        <React.Fragment key={folder.id}>
          <div
            className={`repo-folder-option ${
              selectedFolderId === folder.id ? "selected" : ""
            }`}
            style={{
              paddingLeft: `${depth * 20 + 16}px`,
            }}
            onClick={() => onSelectFolder(folder.id)}
          >
            <Folder size={16} className="me-2" />
            {folder.name}
          </div>

          {renderFolders(folder.id, depth + 1)}
        </React.Fragment>
      ));
  };

  return (
    <div className="modal modal-backdrop-custom d-block" onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="document-modal modal-content text-center"
          style={{
            maxWidth: "500px",
            width: "90%",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header justify-content-center position-relative p-0">
            <button
              className="modal-close-btn position-absolute"
              onClick={onClose}
            >
              <X size={20} />
            </button>
          </div>

          <div className="modal-body modal-body-padding">
            <div className="d-flex justify-content-center align-items-center mb-3">
              <div className="modal-icon-wrapper rounded-circle d-flex justify-content-center align-items-center p-3">
                <FolderTree size={36} className="text-black" />
              </div>
            </div>

            <h5 className="fw-semibold mb-2">Select Destination Folder</h5>

            <p className="mb-3">
              Choose the folder where the uploaded files should be stored.
            </p>

            <div className="repo-folder-tree custom-ak-scollbar">
              <div
                className={`repo-folder-option ${
                  selectedFolderId === null ? "selected" : ""
                }`}
                onClick={() => onSelectFolder(null)}
              >
                <Folder size={16} className="me-2" />
                Root Directory
              </div>

              {renderFolders()}
            </div>
          </div>

          <div className="modal-footer justify-content-center gap-3">
            <button
              className="cancle-btn w-25 border border-1 fw-semibold"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              className="custom-btn w-25"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
